const INTEGRATION_APP_PATH_PATTERN = /\/integration_apps\/([^/]+)\/integration_apps\/([^/?]+)/;

export const resolveIntegrationHubIds = (appId?: string | number, tenantId?: string | number) => {
  const pathMatch = window.location.pathname.match(INTEGRATION_APP_PATH_PATTERN);
  const resolvedAppId = appId ?? pathMatch?.[2];
  const resolvedTenantId = tenantId ?? pathMatch?.[1];

  return {
    appId: resolvedAppId != null && String(resolvedAppId) !== 'undefined' ? String(resolvedAppId) : undefined,
    tenantId: resolvedTenantId != null && String(resolvedTenantId) !== 'undefined' ? String(resolvedTenantId) : undefined
  };
};

export const buildSettingsUrl = (appId?: string | number, tenantId?: string | number) => {
  const { appId: resolvedAppId, tenantId: resolvedTenantId } = resolveIntegrationHubIds(appId, tenantId);
  if (!resolvedAppId || !resolvedTenantId) {
    return undefined;
  }

  const prefix = window.location.href.includes('admin') ? '/admin' : '';
  let path = `${prefix}/integration_apps_settings/${resolvedAppId}/${resolvedTenantId}.json`;
  if (!window.location.host.includes('connect') && !window.location.host.includes('localhost')) {
    path = '/services/connect' + path;
  }
  return path;
};

/**
 * Build Workflow global constants for Field Mappings
 *
 * @param {any} fieldMappings - Field mappings between source and target
 */
export const buildGlobalConstantsForFieldMappings = (fieldMappings: any) => {
  let mappings = {};
  const mappingKeys = Object.keys(fieldMappings);
  if (mappingKeys.length > 0) {
    for (let key of mappingKeys) {
      if (key.startsWith('z-')) {
        // filter out only mappings that have both source and target fields set to a value
        const rawMappings: any[] = (fieldMappings[key] || []).filter(rawMapping => !!rawMapping?.sourceField?.value && !!rawMapping?.targetField?.value);
        rawMappings.forEach(rawMapping => {
          const sourceValue = rawMapping?.sourceField?.value;
          const targetValue = rawMapping?.targetField?.value;
          if (sourceValue) {
            mappings[sourceValue] = targetValue;
          }
        });
      }
    }
  }
  return mappings;
}

/**
 * Build Workflow global constants for Email Configurations
 *
 * @param {{enabled: boolean, failures: boolean, success: boolean, emails: string[]}} emailNotifications - Email notification configurations
 */
export const buildGlobalConstantsForEmailConfigs = (emailNotifications: {
  enabled: boolean;
  failures: boolean;
  warnings: boolean;
  success: boolean;
  emails: string[];
}) => {
  let emailConfigs = {};
  if (emailNotifications.enabled) {
    emailConfigs = {
      'Failures': emailNotifications.failures || false,
      'Warnings': emailNotifications.warnings || false,
      'Success': emailNotifications.success || false,
      'Emails': emailNotifications.emails || []
    };
  }
  return emailConfigs;
}